import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#1a1759"
					title={"Dalyellup Property Management"}
					image={require('./video.jpg')}
					// video={{ mp4: require('../../ContactUs/video.mp4'), webm: require('../../ContactUs/video.webm')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A reputable family business wanting to stand tall.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/dalyellup.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi provided marketing consultancy together with a logo refresh, new website, graphic design and digital campaign.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Marketing Strategy</li>
									<li>Website <a href="https://www.dalypm.com.au" target="_blank">www.dalypm.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Graphic Design</li>
									<li>Google Adwords Advertising Campaign</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Dalyellup Property Management Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Dalyellup Property Management Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Dalyellup Property Management Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Dalyellup Property Management Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/Dalyellup/index.js